import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/Next_logo.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center min-h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      class: "mb-5"
    }, null, -1),
    _createElementVNode("h2", { class: "font-bold text-xl" }, "401", -1),
    _createElementVNode("p", null, "Non puoi visualizzare questa pagina", -1)
  ])))
}